import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnDestroy, OnInit, PLATFORM_ID
} from '@angular/core';

import { isPlatformBrowser, NgClass } from '@angular/common';
import { Subscription } from 'rxjs';

import { SkeletonAnimationEnum, SkeletonAppearanceEnum } from '../../_enums/skeleton.enum';
import { DeviceService } from '../../_services/device.service';
import { ImageRatioEnum } from '../../_enums/image-ratio.enum';
import { SizesEnum } from '../../_enums/sizes.enum';

@Component({
  selector: 'sd-skeleton',
  templateUrl: './skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass]
})
export class SdSkeletonComponent implements OnDestroy, OnInit {
  @Input()
  ratio: ImageRatioEnum = ImageRatioEnum.r4_3;

  @Input()
  count = 1;

  @Input()
  width: 100 | 50 | 80 = 100;

  @Input()
  center = false;

  @Input()
  sizeChangeMobile = true;

  @Input()
  size: SizesEnum;

  @Input()
  loadingText: string;

  @Input()
  appearance: SkeletonAppearanceEnum = SkeletonAppearanceEnum.default;

  @Input()
  animation: SkeletonAnimationEnum = SkeletonAnimationEnum.progress;

  @Input()
  ariaLabel: string;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.width ? 'is-' + this.width : '',
      this.center ? 'is-center' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  SkeletonAppearanceEnum = SkeletonAppearanceEnum;
  SkeletonAnimationEnum = SkeletonAnimationEnum;
  subscriptions = new Subscription();
  items: Array<any> = [];
  isTablet: boolean;
  isMobile: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.items.length = this.count;

    if (isPlatformBrowser(this.platformId) && this.sizeChangeMobile) {
      this.subscriptions.add(
        this.deviceService.isTablet.subscribe((x) => {
          this.isTablet = x;
          this.updateSize();
        }),
      );

      this.subscriptions.add(
        this.deviceService.isMobile.subscribe((x) => {
          this.isMobile = x;
          this.updateSize();
        }),
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private updateSize(): void {
    if (this.isMobile) {
      this.items.length = this.count * 4;
    } else if (this.isTablet) {
      this.items.length = this.count * 2;
    } else {
      this.items.length = this.count;
    }
    this.cdRef.markForCheck();
  }
}
